const PressRelease = () => import(/* webpackChunkName: "pressRelease" */ '@/pages/pressRelease');
const PressReleaseInsights = () => import(/* webpackChunkName: "pressRelease" */ '@/pages/pressReleaseInsights');
const PressReleaseCreate = () => import(/* webpackChunkName: "pressRelease" */ '@/pages/pressRelease/create');
const PressReleaseEdit = () => import(/* webpackChunkName: "pressRelease" */ '@/pages/pressRelease/edit');
export default [
  {
    path: 'pressRelease',
    name: 'Press Release',
    component: PressRelease,
  },
  {
    path: 'pressRelease/create',
    name: 'Press Release - Create',
    component: PressReleaseCreate,
  },
  {
    path: 'pressRelease/edit/:id/:section',
    name: 'Press Release - Edit',
    component: PressReleaseEdit,
  },
  {
    path: 'pressRelease/insights/:id?',
    name: 'Press Release - Insights',
    component: PressReleaseInsights,
  },
];
